// extracted by mini-css-extract-plugin
export default {"container":"academicCareer_container__9fWx3"};